export const CHAT_LEADERSHIP_BADGE_TITLE =
  'Giám đốc chi nhánh / Ban giám đốc';

/** Material icon — khác verified của nhóm official */
export const CHAT_LEADERSHIP_BADGE_ICON = 'workspace_premium';

/** Màu cam nổi — đồng bộ class .chat-leadership-badge */
export const CHAT_LEADERSHIP_BADGE_COLOR = '#f97316';

/**
 * Cuộc trò chuyện 1-1 với user có role lãnh đạo (manager, super_admin).
 *
 * @param {{ type?: string, peer_is_leadership?: boolean }|null|undefined} chatGroup
 * @returns {boolean}
 */
export function isChatLeadershipDmPeer(chatGroup) {
  if (!chatGroup || chatGroup.type !== 'USER') {
    return false;
  }
  return chatGroup.peer_is_leadership === true;
}

/**
 * User có role lãnh đạo (manager, super_admin) — dùng badge trên post/modal tìm kiếm.
 *
 * @param {{ is_leadership?: boolean, peer_is_leadership?: boolean }|null|undefined} user
 * @returns {boolean}
 */
export function userHasLeadershipRole(user) {
  if (!user || typeof user !== 'object') {
    return false;
  }
  return user.is_leadership === true || user.peer_is_leadership === true;
}
